module.exports = __webpack_public_path__ + "media/img/referrals/iframe-5d039d876f7f4fde2ea798c333ef16fa.png";